import { useEffect, useState } from 'react';
import { JurisdictionsEnum } from '@libs/backend-common';
import { getAssetUrl, getJurisdictionBaseUrl } from '@libs/helpers';
const GLOBAL_ASSET_PREFIX = 'eu-';
export const useAssetUrlByJurisdiction = (imgName) => {
    const { jurisdictionId } = getJurisdictionBaseUrl();
    const [generatedUrl, setGeneratedUrl] = useState('');
    useEffect(() => {
        const defaultImgUrl = getAssetUrl(imgName);
        if (jurisdictionId === JurisdictionsEnum.GE) {
            setGeneratedUrl(defaultImgUrl);
        }
        else {
            const img = new Image();
            img.src = getAssetUrl(GLOBAL_ASSET_PREFIX + imgName);
            img.onload = () => {
                setGeneratedUrl(img.src);
            };
            img.onerror = () => {
                setGeneratedUrl(defaultImgUrl);
            };
        }
    }, [imgName, jurisdictionId]);
    return generatedUrl;
};
//# sourceMappingURL=useAssetUrlByJurisdiction.js.map